import React from 'react';
import '../styles/AnimatedLogo.css';

const AnimatedLogo = () => {
    return (
        <div className="logo-container">
        <img src="https://africadataentry.com/wp-content/uploads/2025/02/logo_naninan.png" alt="Logo Naninan" style={{ width: '100px', height: 'auto' }}/>
            {/*<h1 className="animated-logo">📽️Nani 🎞️ Nan 🎬</h1>*/}
        </div>
    );
};

export default AnimatedLogo;

/*<p className="animated-tagline">La pellicule de vos émotions 🎬</p>*/